import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { dashboardActions } from "../../../_actions";
import TableAssign from "../Component/TableAssign";
import * as XLSX from "xlsx";
import AssignModal from "./Modal/AssignModal"
import UpdateModal from "./Modal/UpdateModal"
import DeleteAssignModal from "./Modal/DeleteAssignModal"
import { LuDownload, LuPlus, LuSearch, LuChevronLeft, LuChevronRight, } from 'react-icons/lu';
import moment from "moment";

class AssignTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employees: [],
      showAssignModal: false,
      showUpdateModal: false,
      step: 1,
      updateFormData: {

        assignedId: "",
        introMeetingLink: "",
        introMeetingLinkExpiry: "",
        introMeetingLinkExpired: "",

        caseStudyId: "",
        caseStudyIdExpiry: "",
        caseStudyIdExpired: "",

        rolePlayId: "",
        rolePlayIdExpiry: "",
        rolePlayIdExpired: "",

        caseStudyMeetingLink: "",

        rolePlayMeetingLink: "",
        rolePlayMeetingLinkExpiry: "",
        rolePlayMeetingLinkExpired: "",

        surveyId: "",
        surveyIdExpiry: "",
        surveyIdExpired: "",

        mailIdList: [],

        inboxActivityExpiry: "",
        inboxActivityExpired: "",

      },
      assignFormData: {
        surveyId: "",
        caseStudyId: "",
        rolePlayId: "",
        mailIdList: [],
        employeeId: ""
      },
      searchTerm: "",
      entriesToShow: 20,

      pageNo: 1,
      size: 100,
      keyWord: ""
    };
  }

  componentDidMount() {
    const data = { keyWord: "", pageNo: 1, size: 10000 };
    this.props.dispatch(dashboardActions.getInsightEmployeeList(data));
    const dataTemp = { keyWord: "", pageNo: 1, size: 100000 };
    this.props.dispatch(dashboardActions.getInsightEmpTaskList(dataTemp));
    this.props.dispatch(dashboardActions.getCaseStudyList(dataTemp));
    this.props.dispatch(dashboardActions.getRolePlayList(dataTemp));
    this.props.dispatch(dashboardActions.getInsightSurveyList({}));
    this.props.dispatch(dashboardActions.getInsightMailLibraryList(dataTemp));

  }

  /* FILE UPLOAD */
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const formattedData = jsonData.map((row, index) => ({
        sno: index + 1,
        emp_id: row.emp_id || "",
        name: row.name || "",
        email: row.email || "",
        mobile: row.mobile || "",
        assigned: "No"
      }));

      this.setState((prev) => ({
        employees: [...prev.employees, ...formattedData]
      }));
    };

    reader.readAsBinaryString(file);
  };

  /* MODAL */
  toggleAssignModal = () => {
    this.setState((prev) => ({
      showAssignModal: !prev.showAssignModal,
      step: 1
    }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prev) => ({
      assignFormData: {
        ...prev.assignFormData,
        [name]: value
      }
    }));
  };

  nextStep = () => this.setState((prev) => ({ step: prev.step + 1 }));
  prevStep = () => this.setState((prev) => ({ step: prev.step - 1 }));

  /* MAIL SELECT */
  handleMailSelect = (id) => {
    this.setState((prev) => {
      const exists = prev.assignFormData.mailIdList.includes(id);

      return {
        assignFormData: {
          ...prev.assignFormData,
          mailIdList: exists
            ? prev.assignFormData.mailIdList.filter((m) => m !== id)
            : [...prev.assignFormData.mailIdList, id]
        }
      };
    });
  };

  /* EMPLOYEE SELECT */
  handleEmpSelect = (employeeId) => {
    this.setState((prev) => {
      const isSame = prev.assignFormData.employeeId === employeeId;
      return {
        assignFormData: {
          ...prev.assignFormData,
          employeeId: isSame ? null : employeeId
        }
      };
    });
  };



  /* FINAL SUBMIT */
  handleFinalAssign = (employeeId) => {
    const { assignFormData } = this.state;
    let datax = {
      caseStudyId: assignFormData["caseStudyId"],
      caseStudyMeetingLink: assignFormData["caseStudyMeetingLink"],
      employeeId: assignFormData["employeeId"],
      introMeetingLink: assignFormData["introMeetingLink"],
      mailIdList: assignFormData["mailIdList"],
      rolePlayId: assignFormData["rolePlayId"],
      rolePlayMeetingLink: assignFormData["rolePlayMeetingLink"],
      surveyId: assignFormData["surveyId"]
    }
    console.log("FINAL datax:", datax);

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 100
    };
    this.props.dispatch(dashboardActions.assignInsightEmpTasks(datax, temp));

    this.toggleAssignModal();
  };





  saveUpdateAssign = () => {
    const { updateFormData } = this.state;
    const data = {
      assignedId: updateFormData.id,

      introMeetingLink: updateFormData.introMeetingLink,
      introMeetingLinkExpiry: updateFormData.introMeetingLinkExpiry,
      introMeetingLinkExpired: updateFormData.introMeetingLinkExpired,

      caseStudyId: updateFormData.caseStudyId,
      caseStudyIdExpiry: updateFormData.caseStudyIdExpiry,
      caseStudyIdExpired: updateFormData.caseStudyIdExpired,

      rolePlayId: updateFormData.rolePlayId,
      rolePlayIdExpiry: updateFormData.rolePlayIdExpiry,
      rolePlayIdExpired: updateFormData.rolePlayIdExpired,

      caseStudyMeetingLink: updateFormData.caseStudyMeetingLink ? updateFormData.caseStudyMeetingLink : null,

      rolePlayMeetingLink: updateFormData.rolePlayMeetingLink,
      rolePlayMeetingLinkExpiry: updateFormData.rolePlayMeetingLinkExpiry,
      rolePlayMeetingLinkExpired: updateFormData.rolePlayMeetingLinkExpired,

      surveyId: updateFormData.surveyId,
      surveyIdExpiry: updateFormData.surveyIdExpiry,
      surveyIdExpired: updateFormData.surveyIdExpired,

      inboxActivityExpiry: updateFormData.inboxActivityExpiry,
      inboxActivityExpired: updateFormData.inboxActivityExpired,

      mailIdList: updateFormData.mailIdList
    }

    console.log("data---x---->", data)

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 100
    };
    this.props.dispatch(dashboardActions.updateAssignInsightEmpTasks(data, temp));
    this.setState({ showUpdateModal: false, updateFormData: {} });
  }


  closeUpdateAssign = () => {
    this.setState({ showUpdateModal: false });
  }

  onCloseAssignModal = () => {
    this.setState({ showAssignModal: false })
  }

  onEdit = (value) => {
    this.setState({ showUpdateModal: true, updateFormData: value.data })
  }
  onView = (item) => {
    this.props.history.push("/insightadmin/response/" + item.assignedId);
  };

  onStatus = (item) => {
    this.props.history.push("/insightadmin/status/" + item.assignedId);
  }


  setUpdateFormData = (data) => {
    this.setState({ updateFormData: data })
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getInsightEmpTaskList(data));
  }



  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getInsightEmpTaskListTotal } = this.props.dashboard;
    const totalPages = Math.ceil(getInsightEmpTaskListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };


  deleteTeamAssign = () => {
    this.setState({ showDeleteConfirm: true });
  }

  handleCloseDeleteAssignModal = (value, data) => {
    this.setState({ showDeleteConfirm: value });
  }

  render() {
    const { updateFormData, showUpdateModal, employees, showAssignModal,
      step, assignFormData, pageNo, size, showDeleteConfirm } = this.state;
    const { dashboard } = this.props;

    console.log("assignFormData---//x//--->", assignFormData);


    const {
      getInsightSurveyListData = [],
      getInsightEmpTaskListData = [],
      getInsightEmpTaskListTotal,
      getInsightEmployeeListData = [],
      getCaseStudyListData = [],
      getRolePlayListData = [],
      getInsightMailLibraryListData = []
    } = dashboard;

    const columns = [
      { label: "S.No", key: "sno" },
      // { label: "Emp ID", key: "emp_id" },
      { label: "Name", key: "name" },
      { label: "Email", key: "email" },
      { label: "Code", key: "code" },
      { label: "Assigned Date", key: "createdAt" },
    ];


    const list = (getInsightEmpTaskListData ?? []).map((ele, i) => ({
      sno: i + 1,
      assignedId: ele?.id,
      employeeId: ele?.employeeId?.id,
      emp_id: ele?.employeeId?.emp_id,
      name: ele?.employeeId?.name,
      email: ele?.employeeId?.email,
      code: ele?.employeeId?.code,
      createdAt: ele.createdAt ? moment(ele.createdAt).format("DD MMM YYYY, hh:mm A") : "-",
      data: ele
    }));


    const start = getInsightEmpTaskListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getInsightEmpTaskListTotal);
    const totalPages = Math.ceil(getInsightEmpTaskListTotal / size);


    return (
      <LayoutWrap>
        <div className="md:p-8 p-4 bg-white h-screen overflow-y-auto  ">
          <div className="space-y-4 pb-24">

            {/* HEADER */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Assign Activities</h1>
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                {/* <button className="w-full sm:w-auto flex items-center font-medium justify-center gap-2 px-3 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50">
                  <LuDownload size={20} /> Download
                </button> */}
                <button onClick={this.toggleAssignModal} className="w-full sm:w-auto flex items-center font-medium justify-center gap-2 px-3 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-600">
                  <LuPlus size={20} /> Assign Activity
                </button>
              </div>
            </div>

            {/* CARD */}
            <div className="border border-gray-300 rounded-lg  bg-white ">
              {/* TOOLBAR */}
              <div className="p-3 md:p-4 border-b border-gray-100 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                {/* LEFT */}
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2 text-sm textblack">
                    Show
                    <select
                      className="border border-gray-300 bg-white outline-none rounded-md px-2 py-1 font-semibold"
                      value={this.state.size} onChange={this.handleSizeChange}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    Entries
                  </div>
                </div>

                {/* RIGHT */}
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

                  {/* SEARCH */}
                  {/* <div className="relative w-full sm:w-64">
                    <LuSearch
                      className="absolute left-3 top-1/2 -translate-y-1/2 textblack"
                      size={16}
                    />
                    <input
                      type="text"
                      value={this.state.keyWord}
                      onChange={this.handleSearch}
                      placeholder="Search..."
                      className="w-full pl-9 pr-3 py-2 border border-gray-300 textblack placeholder:text-gray-800 rounded-md text-sm outline-none"

                    />
                  </div> */}

                  {/* PAGINATION */}
                  <div className="flex items-center gap-3 text-sm textblack">
                    <span>{start}-{end}  of {getInsightEmpTaskListTotal}</span>
                    <div className="flex gap-1">
                      <button onClick={this.goPrev} disabled={this.state.pageNo === 1} className="p-1 border rounded">
                        <LuChevronLeft size={18} />
                      </button>
                      <button onClick={this.goNext} disabled={this.state.pageNo === totalPages} className="p-1 border rounded bg-purple-50 text-indigo-600">
                        <LuChevronRight size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <TableAssign
                list={list}
                columns={columns}
                onEdit={this.onEdit}
                onView={this.onView}
                onStatus={this.onStatus}
              // onDelete={this.onDelete}
              />

            </div>
          </div>

          {/* MODAL */}
          {showAssignModal && (
            <AssignModal
              onClose={this.onCloseAssignModal}
              step={step}
              assignFormData={assignFormData}
              empList={getInsightEmployeeListData}

              getCaseStudyListData={getCaseStudyListData}
              getRolePlayListData={getRolePlayListData}
              getInsightSurveyListData={getInsightSurveyListData}
              getInsightMailLibraryListData={getInsightMailLibraryListData}

              handleChange={this.handleChange}
              handleMailSelect={this.handleMailSelect}
              handleEmpSelect={this.handleEmpSelect}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleFinalAssign={this.handleFinalAssign}

            />

          )}


          {/* MODAL */}
          {showUpdateModal && (
            <UpdateModal
              onClose={this.onCloseAssignModal}
              setUpdateFormData={this.setUpdateFormData}
              updateFormData={updateFormData}
              step={step}
              assignFormData={assignFormData}
              empList={getInsightEmployeeListData}
              getCaseStudyListData={getCaseStudyListData}
              getRolePlayListData={getRolePlayListData}
              getInsightSurveyListData={getInsightSurveyListData}
              getInsightMailLibraryListData={getInsightMailLibraryListData}
              handleChange={this.handleChange}
              handleMailSelect={this.handleMailSelect}
              handleEmpSelect={this.handleEmpSelect}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleFinalAssign={this.handleFinalAssign}
              saveUpdateAssign={this.saveUpdateAssign}
              closeUpdateAssign={this.closeUpdateAssign}
            />

          )}

          {showDeleteConfirm ?
            <>
              <DeleteAssignModal deleteTeamAssign={this.deleteTeamAssign} handleCloseDeleteAssignModal={this.handleCloseDeleteAssignModal} />
            </>
            : null}


        </div>
      </LayoutWrap>
    );
  }
}

export default connect((state) => ({ dashboard: state.dashboard }))(
  AssignTask
);